import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

interface EmptyStateProps {
  titleKey: string
  bodyKey: string
  icon: ReactNode
  action?: ReactNode
  /** Tighter card used by history and other secondary screens. */
  compact?: boolean
}

/**
 * Flat white bordered card, matching the Flutter empty states. The action is
 * optional: discovery intentionally has no duplicate create CTA here.
 */
export function EmptyState({
  titleKey,
  bodyKey,
  icon,
  action,
  compact = false,
}: EmptyStateProps) {
  const { t } = useTranslation()
  return (
    <div
      className={`flex flex-col items-center justify-center rounded-[22px] border border-line bg-white px-5 text-center ${
        compact ? 'py-7' : 'py-10'
      }`}
    >
      <span className="grid size-12 place-items-center rounded-full bg-mint text-teal">
        {icon}
      </span>
      <h2 className="mt-3 text-lg font-extrabold">{t(titleKey)}</h2>
      <p className="mt-1.5 max-w-md text-sm text-muted">{t(bodyKey)}</p>
      {action ? <div className="mt-4">{action}</div> : null}
    </div>
  )
}
